// extracted by mini-css-extract-plugin
export var wrapper = "x_b";
export var bg = "x_b9";
export var dots = "x_8";
export var transformMove = "x_cb";
export var circle = "x_cc";
export var transformRotate = "x_cd";
export var bubble = "x_cf";
export var transformScale = "x_cg";